
import { mapState,mapGetters } from 'vuex'
import cms from '~/mixins/common/cms'
import playGames from '~/mixins/common/play-games'
import notifications from '~/mixins/pages/mission-control/notifications'

export default {
   mixins: [cms, playGames,notifications],
   data() {
      return {
        contentItemWidth: 280,
        slideIndex: 0
      }
    },
   computed: {
      ...mapState({
        isLogin: state => state.settings.isLogin,
        isLoading: state => state.games.recommendMatchLoading,
        recommendItems: state => state.games.recommendMatchItems
      }),
      ...mapGetters({
        recommendedMatchItems: 'cms/recommendedMatches'
      }),
      matchedItems() {
         const listLive = this.recommendItems
         const listCMS = this.recommendedMatchItems?.items

         if (listLive?.length && this.recommendedMatchItems?.is_live_match === true) {
            const lang =
               this.handleCookie('wl_locale') ||
               this.defaultLanguage?.language ||
               'en-US'

            return [...listLive]
               .sort((a, b) => {
                  // Fallback to Epoch time (0) if kickOffTime is missing or invalid
                  const timeA = a.kickOffTime || ''
                  const timeB = b.kickOffTime || ''

                  return timeA.localeCompare(timeB) // a - b Ascending
               })
               .map(({ linkInfo, ...item }) => ({
                  ...item,
                  game_info: {
                        [lang]: linkInfo,
                  },
                  game_setting: {
                        language_code: lang,
                        is_active: true,
                        is_maintenance: false,
                        maintenance_start_time: null,
                        maintenance_end_time: null,
                  },
               }))
         }
      
         if (!listCMS?.length) return []

         const mapped = listLive.reduce((acc, a) => {
            const match = listCMS.find(b => this.getLocaleLang(b?.match_info)?.matchId === a?.matchId)
            if (match) acc.push({ ...match, ...a })
            return acc
         }, [])

         return mapped;
      },
      isReady() {
        return !!this.recommendedMatchItems.is_visible && !this.isLoading && this.matchedItems?.length > 0
      },
      realItemWidth(){
        return this.contentItemWidth
      }
   },
   
   methods: {
      isLeageNameOverlow(leagename) {
         return leagename?.length > 35
      },
      betGame(item) {
         if (item === null || item === undefined) return
         if (!this.$cookie.get('token')) {
            this.$store.dispatch('settings/toggleIsLogin')
            this.$store.commit('games/playGameLoading', null)
            this.$router.push('/login')
            return
         }

         const {
            game_type_id: gameTypeId,
            product_id: productId,
            portfolio_uuid: portfolioUuid,
            matchId
         } = item

         const gameInfo =
         item.game_info[this.handleCookie('wl_locale')] ||
         item.game_info[this.defaultLanguage.language]
         if (!gameInfo) return

         const gameId = gameInfo?.game_id
         const gameProviderId = gameInfo?.game_provider_id
         const gameTypeCode = gameInfo?.game_type_code

         let link = `/play-game?platform=${
         this.isMobileDetected() || this.$vuetify.breakpoint.smAndDown ? 'phone' : 'desktop'
         }`

         if (gameId || gameId === 0) link += `&game_id=${gameId}`
         if (gameTypeId) link += `&game_type_id=${gameTypeId}`
         if (gameProviderId) link += `&game_provider_id=${gameProviderId}`
         if (productId) link += `&product_id=${productId}`
         if (portfolioUuid) link += `&portfolio_uuid=${portfolioUuid}`
         if (gameTypeCode) link += `&game_type_code=${gameTypeCode}`
         if(matchId) link +=`&match_id=${matchId}`
         this.$router.push({ path: link })
      },
      getLocalTime(date) {
         // time base GMT(-4) but data is "2026-04-07T15:05:00.000",
         if (!date) return date
         const stripped = this.$dayjs(date).format('YYYY-MM-DDTHH:mm:ss.SSS')
         const localTime = this.$dayjs.utc(stripped).add(4, 'hour').local()
         
         return localTime;
      },
      isStartedGame(date, gameTime){
         /// wait backend confirm, how to detect game started
         // reverse condition at RecommendedMatches.vue.bg-score (VS & time) 
         // const dateLocal = this.getLocalTime(date)
         // const isStarted = this.$dayjs().isAfter(this.$dayjs(dateLocal)); // true not yet started
         // return  isStarted && gameTime;
        return false;
      },
      kicksOffTime(date, gameTime) {
        const kickOff = this.getLocalTime(date)
        if(!date || !kickOff.isValid()){
          return date
        }

        const isStarted = this.isStartedGame(date, gameTime)


        if (isStarted) {
           return this.timeAgo(date)
         } else {
           return kickOff.format('YYYY-MM-DD HH:mm')
        }
      },
      isReverse(point, isReverse) {
        const num = parseFloat(point)
        if (isNaN(num)) return point

        if (!isReverse) return num

        if (num > 0) return -Math.abs(num)
        if (num < 0) return Math.abs(num)

        return num
      },
       getContentWidth() {
        const client = process.client
        if (client) {
          const val = this.$refs?.refRecommendedMatches?.clientWidth
          if (val) {
            // Display only 4 card if more than that should click arrow right icon above
            this.contentItemWidth = Math.ceil(val / 4) - 12
          }
        } else {
          setTimeout(() => {
            this.getContentWidth()
          }, 1000)
        }
      },
      onNext() {
         const swiper = this.$refs.mySwiper?.$el?.swiper
         if (!swiper) return
         swiper.slideNext()
         this.slideIndex = swiper.realIndex % this.matchedItems.length
      },
      onBack() {
         const swiper = this.$refs.mySwiper?.$el?.swiper
         if (!swiper) return
         swiper.slidePrev()
         this.slideIndex = swiper.realIndex % this.matchedItems.length
      },
      onSlideChange() {
         const swiper = this.$refs.mySwiper?.$el?.swiper
         if (!swiper) return
         this.slideIndex = swiper.realIndex % this.matchedItems.length
      },
      doManualChangeSlider(index) {
         const swiper = this.$refs.mySwiper?.$el?.swiper
         if (!swiper) return
         swiper.slideToLoop(index) 
         this.slideIndex = index
      },
   }
}